var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1B1B",
    fillRule: "evenodd",
    d: "M11.151 12.755a7.04 7.04 0 1 1 1.45-1.398l3.083 2.905a1.006 1.006 0 1 1-1.38 1.464zm.917-5.715a5.028 5.028 0 1 1-10.056 0 5.028 5.028 0 0 1 10.056 0",
    clipRule: "evenodd"
  })));
};
export default SvgSearch;